import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ellipsis-h",
  "use": "ellipsis-h-usage",
  "viewBox": "0 0 22 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 28\" id=\"ellipsis-h\"><path fill=\"currentColor\" d=\"M6 11.5v3A1.5 1.5 0 014.5 16h-3A1.5 1.5 0 010 14.5v-3A1.5 1.5 0 011.5 10h3A1.5 1.5 0 016 11.5zm8 0v3a1.5 1.5 0 01-1.5 1.5h-3A1.5 1.5 0 018 14.5v-3A1.5 1.5 0 019.5 10h3a1.5 1.5 0 011.5 1.5zm8 0v3a1.5 1.5 0 01-1.5 1.5h-3a1.5 1.5 0 01-1.5-1.5v-3a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 011.5 1.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol